import React, { useState, useRef, useEffect } from "react";
import Input from "../Input";
import TextInput from "../TextInput";
import Dropdown from "../Dropdown";
import search from '../../Assets/Icons/search.png';
import closeIcon from "../../Assets/Icons/close.png";
import uploadIcon from "../../Assets/Icons/upload.png";
import pluseIcon from "../../Assets/Icons/Pluse.png";
import { ORG_CLIENT_SEARCH_TO_ADD_GROUPMEMBER, ORG_ADD_DOCUMENT_RACK, ORG_UPDATE_DOCUMENT_RACK, ORG_DELETE_DOCUMENT_RACK } from '../../ApiServices/BaseURL';
import { postData } from '../../ApiServices/ApiService';
import Loader from '../Loader';
import errorIcon from '../../Assets/Icons/error_message.png';

const CreateEntryModal = ({ isOpen, onClose, onValueChange, documentData, setSelectedDocument, modalMode }) => {
  //console.log("documentData in rack update", documentData)
  const sourceOptions = [
    { label: "Inward (Sent by Client)", value: 1 },
    { label: "Outward (Sent by Employee)", value: 2 },
  ];
  const documentTypeOptions1 = ["PDF", "Excel"];
  const documentTypeOptions = [
    { label: "Internal", value: 1 },
    { label: "Client Documents", value: 2 },
  ];
  const deliveryTypeOptions = [
    { label: "Email", value: "EMAIL" },
    { label: "Whatsapp", value: "WATSAPP" },
    { label: "Physical", value: "PHYSICAL" },
    { label: "Others", value: "OTHERS" },
  ];
  const [clientName, setClientName] = useState("");
  const [documentName, setDocumentName] = useState("");
  const [documentNumber, setDocumentNumber] = useState("");
  const [documentType, setDocumentType] = useState();
  const [source, setSource] = useState();
  const [deliveryType, setDeliveryType] = useState();
  const fileInputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [employeeList, setEmployeeList] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [documentTypeError, setDocumentTypeError] = useState('')
  const [deliveryTypeError, setDeliveryTypeError] = useState('')
  const [documentNumberError, setDocumentNUmberError] = useState('')
  const [sourceError, setSourceError] = useState('');
  const [uploadedFileName, setUploadedFileName] = useState('');
  const [base64File, setBase64File] = useState('');
  const [fileExtension, setFileExtension] = useState('');
  const [updateKycError, setUpdateKycError] = useState('');
  const [documentUploadError, setDocumentUploadError] = useState('');
  const [success, setSuccess] = useState('');
  const [uploadDocumentLoading, setUploadDocumentLoading] = useState(false);
  const [uploadDocumentError, setUploadDocumentError] = useState('');
  const [clientSearchError, setClientSearchError] = useState('');

  const [documentNameError, setDocumentNameError] = useState('');
  const [description, setDescription] = useState('');

  const handleFileUploadClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange1 = (event) => {
    const file = event.target.files[0];
    if (file) {
      //console.log("Uploaded file:", file.name);
    }
  };

  useEffect(() => {
    if (isOpen && documentData) {
      //console.log("documentData", documentData);

      // Set client name
      setSearchUser(documentData.client_name || '');
      setDescription(documentData.doc_description || '');

      // Set document name
      setDocumentName(documentData.doc_name || '');

      // Set document number
      setDocumentNumber(documentData.doc_number || '');

      // Initialize document type based on doc_type
      const selectedDocumentType = documentTypeOptions.find(option => option.value === documentData.doc_type);
      setDocumentType(selectedDocumentType?.value || documentTypeOptions[0]?.value);

      // Initialize source based on source
      const selectedSource = sourceOptions.find(option => option.value === documentData.source);
      setSource(selectedSource?.value || sourceOptions[0]?.value);

      // Initialize delivery type based on delivery_type
      const selectedDeliveryType = deliveryTypeOptions.find(option => option.value === documentData.delivery_type);
      setDeliveryType(selectedDeliveryType?.value || deliveryTypeOptions[0]?.value);
    }
  }, [isOpen, documentData]);

  const handleSearchInputChange = (value) => {
    setSearchUser(value);
    if (!value) {
      setSelectedEmployee(null)
    }
  }
  const handleSelectedEmployee = (employee) => {
    setSelectedEmployee(employee); // Set selected client data
    setSearchUser(employee?.client_name); // Update TextInput with the selected client's name
    setEmployeeList([]); // Clear the dropdown
  };

  const [searchUser, setSearchUser] = useState('');

  const handleSearchEmployee = async () => {

    try {
      setError('');
      setClientSearchError('')
      if (!searchUser) {
        setClientSearchError('Please enter valid text'); return;
      }
      setLoading(true);
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
      const payLoad = { emp_id_auth: storedUserInfo?.emp_id, search_type: "GENERIC", search_word: searchUser }

      //console.log('handleSearchEmployee payload', payLoad);
      // Make the API call
      const response = await postData(ORG_CLIENT_SEARCH_TO_ADD_GROUPMEMBER, payLoad);
      const responseData = await response.json();
      //console.log('response Data', responseData);

      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            // setAddEmployeeError('')
            setEmployeeList(responseData?.dataJ || []);
            //   setError(responseData?.info);
            setTimeout(() => {
              // handleClose();
              // onValueChange();
            }, 2000);
          } else {
            setError(responseData?.info || 'Failed to fetch inventory data. Please try again.');
          }
        } else {
          setError(responseData?.info || 'Failed to fetch Task Categorie data.');
        }
      }
      // Token-related errors: 400, 401, 403
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
          setError('Unauthorized access. Your session may have expired. Please log in again.');
          // Optionally, redirect to the login page or refresh the token
          // Example: redirectToLogin();
        } else {
          setError(responseData?.info || 'Bad request. Please check the request parameters.');
        }
      }
      // Internal Server Error: 500
      else if (response?.status === 500) {
        setError(responseData?.info || 'Internal Server Error. Please try again later.');
      }
      // Unexpected or network-related errors
      else {
        setError('Unexpected error occurred. Please try again later.');
      }
    } catch (error) {
      // Handle various error scenarios
      if (error.response) {
        // Server responded with a status outside the 2xx range
        setError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to fetch Task Categorie data. Please try again.'}`);
      } else if (error.request) {
        // Request was made but no response was received
        setError('No response received from the server. Please check your network connection and try again.');
      } else {
        // An error occurred in setting up the request
        setError(`Failed to fetch Task Categorie data. Please check your network connection and try again.`);
      }
    } finally {
      setLoading(false);
    }

    // onValueChange(teamData);
    // onClose();
  };

  const handleFileChange = (event) => {
    setDocumentUploadError('');
    const files = event.target.files;

    if (files && files.length > 0) {
      const file = files[0];
      const fileName = file.name;
      const fileSize = file.size; // File size in bytes
      const maxFileSize = 2 * 1024 * 1024;
      const fileExtension = fileName.split('.').pop(); // Extract the file extension
      console.log("fileName", fileName);

      //console.log("Uploaded File Name:", fileName);
      //console.log("File Extension:", fileExtension);
      setUploadedFileName(fileName);

      if (fileSize > maxFileSize) {
        setDocumentUploadError("File size exceeds the maximum limit of 2MB.");
        return;
      }

      const reader = new FileReader();

      try {
        reader.onload = () => {
          try {
            const base64String = reader.result.split(',')[1]; // Extract Base64 string from result
            //console.log("Base64 Encoded File:", base64String);

            setBase64File(base64String); // Add the Base64 string to the payload
            // Optionally, save the file extension in state or payload
            setFileExtension(fileExtension);
          } catch (parseError) {
            console.error("Error parsing file to Base64:", parseError);
            setDocumentUploadError("Failed to process the file. Please try again.");
          }
        };

        reader.onerror = (error) => {
          console.error("Error reading file:", error);
          setDocumentUploadError("Failed to read the file. Please try again.");
        };

        reader.readAsDataURL(file); // Convert file to Base64 string
      } catch (readError) {
        console.error("File upload error:", readError);
        setDocumentUploadError("An unexpected error occurred during the file upload. Please try again.");
      }
    } else {
      // setDocumentUploadError("No file selected. Please choose a file to upload.");
    }
  };

  const handleDrop = (e) => {
    const files = e.dataTransfer.files; // Get the files from the drop event
    if (files && files.length > 0) {
      //console.log("Dropped files:", files);
      handleFileChange({ target: { files } }); // Reuse handleFileChange for processing
    }
  };

  const handleClose = () => {
    setError('');
    onClose();
    setSuccess('');
    setBase64File('');
    setDocumentName('');
    setUpdateKycError('');
    setDeliveryType();
    setDocumentType();
    setDocumentNumber('')
    setSource();
    setUploadedFileName('')
    setDocumentNameError('');
    setDocumentUploadError('');
    setDocumentNUmberError('');
    setDeliveryTypeError('');
    setDocumentTypeError('');
    setSourceError('');
    setClientSearchError('');
    setSearchUser('');
    setDescription('');
    setEmployeeList([]);
    setSelectedEmployee(null);
  }

  const clearFeilds = () => {
    setDocumentName('');
    setDescription('');
    setDocumentType('');
    setSource('');
    setDeliveryType('');
    setBase64File('');
    setSearchUser('');
    setSelectedEmployee('');
  }

  const handleUploadDocument = async () => {

    try {
      setError('');
      setUploadDocumentError('')
      setDocumentNameError('');
      setDocumentUploadError('');
      setDocumentNUmberError('');
      setDeliveryTypeError('');
      setDocumentTypeError('');
      setSourceError('');
      setClientSearchError('')
      if (!selectedEmployee?.client_id) {
        setClientSearchError('Please search valid client'); return;
      }
      if (!documentType) {
        setDocumentTypeError("Please select document type");
        return
      }
      // if(!description){
      //   setDocumentDescriptionError("Please enter document description");
      //   return
      // }

      // if(!documentNumber){
      //   setDocumentNUmberError("Please enter document number");
      //   return
      // }
      // if (!source) {
      //   setSourceError("Please select source");
      //   return
      // }
      // if (!deliveryType) {
      //   setDeliveryTypeError("Please select delivery type");
      //   return
      // }
      if (!base64File) {
        setDocumentUploadError("Please upload document");
        return
      }
      if (!documentName) {
        setDocumentNameError("Please enter document name");
        return
      }
      const finalDocumentName = documentName?.trim() ? documentName : uploadedFileName?.split('.')[0];
      if (!finalDocumentName) {
        setDocumentNameError("Please enter document name");
        return
      }
      // if (!searchUser) {
      //   setError('Please enter valid text'); return;
      // }         
      setUploadDocumentLoading(true);
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
      const payLoad = { emp_id_auth: storedUserInfo?.emp_id, client_id: selectedEmployee?.client_id, doc_name: finalDocumentName, doc_name_with_ext: `${finalDocumentName}.${fileExtension}`, doc_upload_via: deliveryType, doc_description: description, doc_base_64: base64File, doc_is_internal: documentType, doc_source_id: source, doc_class: 'DOC-RACK' }

      //console.log('handleadddocumentRack payload', payLoad);
      // Make the API call
      const response = await postData(ORG_ADD_DOCUMENT_RACK, payLoad);
      const responseData = await response.json();
      //console.log('response Data', responseData);

      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            setUploadDocumentError('')
            // setEmployeeList(responseData?.dataJ || []);
            setSuccess(responseData?.info);
            clearFeilds();
            setTimeout(() => {
              handleClose();
              onValueChange();
              setSelectedDocument(null);
            }, 3000);
          } else {
            setUploadDocumentError(responseData?.info || 'Failed to upload document. Please try again.');
          }
        } else {
          setUploadDocumentError(responseData?.info || 'Failed to upload document.');
        }
      }
      // Token-related errors: 400, 401, 403
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
          setUploadDocumentError('Unauthorized access. Your session may have expired. Please log in again.');
          // Optionally, redirect to the login page or refresh the token
          // Example: redirectToLogin();
        } else {
          setUploadDocumentError(responseData?.info || 'Bad request. Please check the request parameters.');
        }
      }
      // Internal Server Error: 500
      else if (response?.status === 500) {
        setUploadDocumentError(responseData?.info || 'Internal Server Error. Please try again later.');
      }
      // Unexpected or network-related errors
      else {
        setUploadDocumentError('Unexpected error occurred. Please try again later.');
      }
    } catch (error) {
      // Handle various error scenarios
      if (error.response) {
        // Server responded with a status outside the 2xx range
        setUploadDocumentError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to upload document. Please try again.'}`);
      } else if (error.request) {
        // Request was made but no response was received
        setUploadDocumentError('No response received from the server. Please check your network connection and try again.');
      } else {
        // An error occurred in setting up the request
        setUploadDocumentError(`Failed to upload document. Please check your network connection and try again.`);
      }
    } finally {
      setUploadDocumentLoading(false);
    }

    // onValueChange(teamData);
    // onClose();
  };

  const handleUpdateDocument = async () => {

    try {
      setError('');
      setUploadDocumentError('')
      setDocumentNameError('');
      setDocumentUploadError('');
      setDocumentNUmberError('');
      setDeliveryTypeError('');
      setDocumentTypeError('');
      setSourceError('');
      setClientSearchError('')
      if (!searchUser) {
        setClientSearchError('Please enter valid text'); return;
      }
      if (!documentType) {
        setDocumentTypeError("Please select document type");
        return
      }
      if (!documentName) {
        setDocumentNameError("Please enter document name");
        return
      }
      // if(!description){
      //   setDocumentDescriptionError("Please enter document description");
      //   return
      // }
      // if(!documentNumber){
      //   setDocumentNUmberError("Please enter document number");
      //   return
      // }
      if (!source) {
        setSourceError("Please select source");
        return
      }
      if (!deliveryType) {
        setDeliveryTypeError("Please select delivery type");
        return
      }
      // if(!base64File){
      //   setDocumentUploadError("Please upload document");
      //   return
      // }
      // if (!searchUser) {
      //   setError('Please enter valid text'); return;
      // }         
      setUploadDocumentLoading(true);
      const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
      const payLoad = { emp_id_auth: storedUserInfo?.emp_id, client_id: documentData.client_id, doc_id: documentData.doc_id, doc_name: documentName, doc_description: description, doc_upload_via: deliveryType, doc_is_internal: documentType, doc_source_id: source }

      //console.log('handleadddocumentRack payload', payLoad);
      // Make the API call
      const response = await postData(ORG_UPDATE_DOCUMENT_RACK, payLoad);
      const responseData = await response.json();
      //console.log('response Data', responseData);

      // Check for success (200) and internal status code
      if (response?.status === 200) {
        if (responseData?.statusCode === 200) {
          if (responseData?.message.toLowerCase() === 'success') {
            setUploadDocumentError('')
            // setEmployeeList(responseData?.dataJ || []);
            setSuccess(responseData?.info);
            setTimeout(() => {
              handleClose();
              onValueChange();
            }, 3000);
          } else {
            setUploadDocumentError(responseData?.info || 'Failed to upload document. Please try again.');
          }
        } else {
          setUploadDocumentError(responseData?.info || 'Failed to upload document.');
        }
      }
      // Token-related errors: 400, 401, 403
      else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
        if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
          setUploadDocumentError('Unauthorized access. Your session may have expired. Please log in again.');
          // Optionally, redirect to the login page or refresh the token
          // Example: redirectToLogin();
        } else {
          setUploadDocumentError(responseData?.info || 'Bad request. Please check the request parameters.');
        }
      }
      // Internal Server Error: 500
      else if (response?.status === 500) {
        setUploadDocumentError(responseData?.info || 'Internal Server Error. Please try again later.');
      }
      // Unexpected or network-related errors
      else {
        setUploadDocumentError('Unexpected error occurred. Please try again later.');
      }
    } catch (error) {
      // Handle various error scenarios
      if (error.response) {
        // Server responded with a status outside the 2xx range
        setUploadDocumentError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to upload document. Please try again.'}`);
      } else if (error.request) {
        // Request was made but no response was received
        setUploadDocumentError('No response received from the server. Please check your network connection and try again.');
      } else {
        // An error occurred in setting up the request
        setUploadDocumentError(`Failed to upload document. Please check your network connection and try again.`);
      }
    } finally {
      setUploadDocumentLoading(false);
    }

    // onValueChange(teamData);
    // onClose();
  };
  const [openDropdown, setOpenDropdown] = useState(null); // Tracks the currently open dropdown
  const toggleDropdown = (dropdownName) => {
    setOpenDropdown((prev) => (prev === dropdownName ? null : dropdownName));
  };

  const dropdownRefs = useRef({}); // Ref for dropdown

  // Handle clicks outside dropdowns
  useEffect(() => {
    const handleClickOutside = (event) => {
      const isOutside = Object.keys(dropdownRefs.current).every(
        (key) => dropdownRefs.current[key] && !dropdownRefs.current[key].contains(event.target)
      );
      if (isOutside) {
        setOpenDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (!documentName && documentName !== uploadedFileName?.split('.')[0]) {
      setDocumentName(uploadedFileName?.split('.')[0] || "");
    }
  }, [uploadedFileName])

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="close-button" onClick={() => { handleClose(); }}>
          <img src={closeIcon} alt="Close" style={styles.closeIcon} />
        </button>
        <h2 className="modal-title">{documentData ? `Update Document` : 'Add Document'}</h2>
        <hr className="title-divider" />
        {/* <div className="filter-field" style={{ paddingBottom: '10px' }}>
                    <label>Client Name</label>
                    <TextInput
                        type="text"
                        placeholder="Enter client name"
                        value={clientName}
                        onChange={(e) => setClientName(e.target.value)}
                        right={<img src={search} alt="Search" className="search-icon" />}
                    />
                </div> */}
        <div className="form-grid">
          <div>
            <div className="filter-field" style={{ width: '100%' }}>
              <label
                style={{
                  ...styles.labaleStyle,
                  // marginBottom: '8px',
                  display: 'block',
                }}
              >
                Client Name
              </label>
              <TextInput
                type="text"
                placeholder="Client Name"
                value={searchUser}
                onChange={(e) => handleSearchInputChange(e.target.value)}
                onRightClick={!!documentData ? null : handleSearchEmployee}
                width={270}
                right={
                  loading ? (
                    <Loader loading={loading} color={'var(--primary-loader-color)'} size='small' /> // Show loader when loading
                  ) : (
                    <img src={search} alt="Search" style={{ cursor: 'pointer', height: '20px', width: '20px' }} />
                  )
                }
                style={{ padding: '20px 10px' }}
                errorMessage={error || clientSearchError}
                disabled={!!documentData}
              />
              {employeeList.length > 0 && (
                <ul style={styles.dropdownList}>
                  {employeeList.map((employee, index) => (
                    <li
                      key={employee?.emp_id}
                      onClick={() => handleSelectedEmployee(employee)}
                      style={{
                        ...styles.dropdownItem,
                        borderBottom: index !== employeeList.length - 1 ? '1px solid #ccc' : 'none', // Add line below except last item
                      }}
                    >
                      {employee?.client_name}
                    </li>
                  ))}
                </ul>
              )}

            </div>
          </div>
          <Dropdown
            ref={(el) => (dropdownRefs.current["documentType"] = el)}
            isOpen={openDropdown === "documentType"}
            toggleDropdown={() => toggleDropdown("documentType")}
            label="Document Type"
            options={documentTypeOptions}
            value={documentTypeOptions.find((option) => option.value === documentType)}
            onChange={(selectedOption) => setDocumentType(selectedOption.value)}
            width={250}
            errorMessage={documentTypeError}
          />

          <Input
            label="Document Name"
            placeholder="Enter Document Name"
            // value={documentName}
            value={documentName}
            onChange={(e) => setDocumentName(e.target.value)}
            errorMessage={documentNameError}
            width={250}
          />
          {/* {modalMode === "edit" && (
                <Input
                type="number"
                label="Document No."
                placeholder="Enter Document Number"
                value={documentNumber}
                // onChange={(e) => setDocumentNumber(e.target.value)}
              //   onChange={(e) => {
              //     const value = e.target.value;
              //     if (/^\d*$/.test(value)) {
              //         setDocumentNumber(value);
              //     }
              // }}
              readOnly={modalMode === "edit"} 
                width={250}
                // errorMessage={documentNumberError}
                />
              )} */}
          <Dropdown
            ref={(el) => (dropdownRefs.current["Source"] = el)}
            isOpen={openDropdown === "Source"}
            toggleDropdown={() => toggleDropdown("Source")}
            label="Source"
            options={sourceOptions}
            value={sourceOptions.find((option) => option.value === source)}
            onChange={(selectedOption) => setSource(selectedOption.value)}
            width={250}
            errorMessage={sourceError}
          />
          <Dropdown
            ref={(el) => (dropdownRefs.current["Delivery"] = el)}
            isOpen={openDropdown === "Delivery"}
            toggleDropdown={() => toggleDropdown("Delivery")}
            label="Delivery Type"
            options={deliveryTypeOptions}
            value={deliveryTypeOptions.find((option) => option.value === deliveryType)}
            onChange={(selectedOption) => setDeliveryType(selectedOption.value)}
            width={250}
            errorMessage={deliveryTypeError}
          />
        </div>
        <div style={styles.fullWidth}>
          <Input
            label="Description"
            placeholder="Enter Description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            width={'100%'}
          // errorMessage={documentDescriptionError}
          />
        </div>
        {!documentData && (
          <div
            style={styles.uploadContainer}
            onDragOver={(e) => e.preventDefault()} // Prevent default drag behavior
            onDrop={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleDrop(e);
            }}
            onClick={(e) => {
              e.stopPropagation(); // Prevent event bubbling
              fileInputRef.current?.click(); // Programmatically trigger file input click
            }}
          >
            <div style={styles.uploadBox}>
              <span style={styles.uploadCircle}>
                <img src={pluseIcon} alt="Plus Icon" style={{ ...styles.iconImage, filter: 'brightness(0) invert(0)' }} />
              </span>
              <p style={uploadedFileName ? styles.uploadedFileName : styles.uploadText}>
                {uploadedFileName || // Show file name if uploaded
                  "Upload Document, Drop here or click on upload"}
              </p>
              <img src={uploadIcon} alt="Upload Icon" style={{ ...styles.uploadIconImage, flexShrink: 0, marginLeft: 'auto', height: '25px', width: '25px' }} />
              <input
                type="file"
                ref={fileInputRef}
                style={styles.fileInput}
                onChange={handleFileChange} // Handle file selection
                onClick={(e) => e.stopPropagation()} // Prevent double triggering
              />
            </div>
          </div>
        )}
        {documentUploadError && <div className="list-error-msg" style={{ display: 'flex', padding: '5px' }}><img
          src={errorIcon}
          alt="Error"
          style={{ width: "12px", height: "12px", marginRight: '4px' }}
        />{documentUploadError} </div>}
        <hr className="footer-divider" />
        <div className="button-container" style={{ alignItems: 'center' }}>
          <button
            className="add-client-button"
            // onClick={handleUploadDocument}
            onClick={documentData ? handleUpdateDocument : handleUploadDocument}
            disabled={uploadDocumentLoading}
            style={{
              paddingLeft: '30px',
              paddingRight: '30px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '10px', // Add spacing between text and loader
              position: 'relative',
              opacity: uploadDocumentLoading ? 0.5 : 1, // Reduce opacity when loading
              cursor: uploadDocumentLoading ? 'not-allowed' : 'pointer',
            }}
          >
            <span>{documentData ? 'Update' : 'Add'}</span>
            {uploadDocumentLoading && (
              <Loader loading={uploadDocumentLoading} color={'var(--background-color)'} size="small" />
            )}
          </button>
          <button className="cancel-button" onClick={() => { handleClose(); }}>
            Cancel
          </button>
          {success && <div className="list-success-msg" style={{ marginBottom: '3px' }}>{success} </div>}
          {uploadDocumentError && <div className="list-error-msg" style={{ marginBottom: '3px' }}>{uploadDocumentError} </div>}
        </div>
      </div>
    </div>
  );
};

const styles = {
  closeIcon: {
    width: "12px",
    height: "12px",
  },
  uploadContainer: {
    marginTop: '20px',
    width: '100%',
    // paddingBottom:'20px'
  },
  uploadBox: {
    width: '100%',
    border: '1px dashed var(--web-title-text-color)',
    borderRadius: '10px',
    padding: '15px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    cursor: 'pointer',
    boxSizing: 'border-box',
    position: 'relative', // Position relative to contain the hidden input
  },
  uploadCircle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '35px',
    height: '35px',
    borderRadius: '50%',
    backgroundColor: '#f0f0f0',
  },
  plusIcon: {
    fontSize: '16px',
    color: '#333',
  },
  uploadText: {
    flex: 1,
    color: '#262626',
    fontSize: '12px',
    fontFamily: 'Roboto',
    fontWeight: 400
  },
  uploadArrow: {
    fontSize: '18px',
    color: '#555',
  },
  fileInput: {
    display: "none",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-start",
    gap: "10px",
    marginTop: "20px",
  },
  resourceImage: {
    width: "25px",
    height: "25px",
    backgroundColor: "#D9D9D9",
    borderRadius: "50%",
  },
  iconImage: {
    width: '15px',
    height: '15px',
    padding: '2px'
  },
  dropdownList: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    backgroundColor: '#fff',
    border: '1px solid #ccc',
    borderRadius: '4px',
    maxHeight: '200px',
    overflowY: 'auto',
    zIndex: 1000,
    padding: 0, // Remove default padding
    margin: 0, // Remove default margin
    listStyleType: 'none', // Remove the dots
  },
  dropdownItem: {
    padding: '10px',
    cursor: 'pointer',
    borderBottom: '1px solid #eee', // Default for all items
    backgroundColor: '#fff',
    hover: {
      backgroundColor: '#f0f0f0',
    },
  },
  fullWidth: {
    gridColumn: "span 2",
    width: "100%", // Full width
    marginTop: '14px'
  },
};

export default CreateEntryModal;
